module.exports = __webpack_public_path__ + "media/day/302-05655fd0.svg";